import JSEncrypt from "jsencrypt";

import React, { useState } from "react";
import toast from "react-hot-toast";

import { useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

import { loginAPI } from "../service/AuthService";

import { PUBLIC_KEY } from "../utils/constants";

import { Button, InputAdornment } from "@material-ui/core";

import { TextField } from "@mui/material";
import Footer from "./components/Footer";

import { Stack } from "react-bootstrap";

import { generateHash } from "../service";
import logo from "../assets/logo.png";

function LoginPage() {
  const dispatch = useDispatch();
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const togglePassword = () => setShowPassword(!showPassword);


  const login = async (e) => {
    let encryptedPassword = new JSEncrypt();
    encryptedPassword.setPublicKey(PUBLIC_KEY);
    encryptedPassword = encryptedPassword.encrypt(password);
    setLoading(true);
    let fingerprint = await generateHash();
    localStorage.setItem("fingerprint", fingerprint);

    var { data, code, message, response, error, status } = await loginAPI(
      userName,
      password
    );

    if (code == 200) {
      localStorage.setItem("token", response.token);
      setLoading(false);

      dispatch({
        type: "accountData/setUserData",
        payload: response,
      });

      dispatch({
        type: "accountData/setLoginPopSate",
        payload: false,
      });

      dispatch({
        type: "accountData/setChangePopSate",
        payload: response.resetRequired,
      });
      navigate("/tc");
    } else if (code == 500) {
      toast.error(response);
    } else if (code == 403) {
      toast.error(status);
    } else if (code == 401) {
      toast.error(response);
    } else {
      toast.error("Something went wrong or Account is not active");
    }

    setLoading(false);
  };

  return (
    <div id="app" className="bootstrap-wrapper">
      {" "}
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          top: 16,
          left: 16,
          right: 16,
          bottom: 16,
          pointerEvents: "none",
        }}
      />{" "}
      <main>
        {" "}
        <div
          style={{
            backgroundImage: "url(./assets/images/bg.jpg)",
          }}
          className="container cbox"
        >
          {" "}
          <div className="row center-xs">
            {" "}
             <h1 style={{
              marginBottom: 20,
              fontSize: 30,
              color: "#FF8C00"
             }}><b>Hrf999</b></h1>
            <div className="login-form">
              {" "}
             
              <div
                className="flex-row logo"
                style={{
                  marginBottom: 5,
                  width: "100%",
                }}
              >
                {" "}
              
                  {" "}
                  <a
                    href="javascript:void(0)"
                    style={{
                      color: "var(--primary-color)",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                
                    
                    }}
                  >
                    {" "}
                   <h1><b>Hrf999</b></h1>
                  </a>{" "}
                
              </div>{" "}
              <div className="flex-row">
                {" "}
                <label htmlFor="username" className="lf--label">
                  {" "}
                  <svg x="0px" y="0px" width="12px" height="13px">
                    {" "}
                    <path
                      fill="#FFF"
                      d="M8.9,7.2C9,6.9,9,6.7,9,6.5v-4C9,1.1,7.9,0,6.5,0h-1C4.1,0,3,1.1,3,2.5v4c0,0.2,0,0.4,0.1,0.7 C1.3,7.8,0,9.5,0,11.5V13h12v-1.5C12,9.5,10.7,7.8,8.9,7.2z M4,2.5C4,1.7,4.7,1,5.5,1h1C7.3,1,8,1.7,8,2.5v4c0,0.2,0,0.4-0.1,0.6 l0.1,0L7.9,7.3C7.6,7.8,7.1,8.2,6.5,8.2h-1c-0.6,0-1.1-0.4-1.4-0.9L4.1,7.1l0.1,0C4,6.9,4,6.7,4,6.5V2.5z M11,12H1v-0.5 c0-1.6,1-2.9,2.4-3.4c0.5,0.7,1.2,1.1,2.1,1.1h1c0.8,0,1.6-0.4,2.1-1.1C10,8.5,11,9.9,11,11.5V12z"
                    />{" "}
                  </svg>{" "}
                </label>{" "}
                <input
                  id="username"
                  placeholder="Username"
                  type="text"
                  value={userName}
                  onChange={(e) => setUsername(e.target.value)}
                  className="lf--input"
                />{" "}
              </div>{" "}
              <div className="flex-row" >
                {" "}
                <label htmlFor="password" className="lf--label" onClick={togglePassword} style={{ cursor: "pointer" }}>
                  {" "}
                  <svg x="0px" y="0px" width="15px" height="5px">
                    {" "}
                    <g>
                      {" "}
                      <path
                        fill="#FFF"
                        d="M6,2L6,2c0-1.1-1-2-2.1-2H2.1C1,0,0,0.9,0,2.1v0.8C0,4.1,1,5,2.1,5h1.7C5,5,6,4.1,6,2.9V3h5v1h1V3h1v2h1V3h1 V2H6z M5.1,2.9c0,0.7-0.6,1.2-1.3,1.2H2.1c-0.7,0-1.3-0.6-1.3-1.2V2.1c0-0.7,0.6-1.2,1.3-1.2h1.7c0.7,0,1.3,0.6,1.3,1.2V2.9z"
                      />{" "}
                    </g>{" "}
                  </svg>{" "}
                </label>{" "}
                <input
                  id="password"
                  placeholder="Password"
                  // type="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="lf--input"
                />{" "}
              </div>{" "}
              <input
                onClick={login}
                type="submit"
                className="lf--submit"
                defaultValue="LOGIN"
              />{" "}
              <p
                style={{
                  color: "black",
                }}
              >
                {" "}
                Note- This Website is not for Indian Territory{" "}
              </p>{" "}
              <p
                style={{
                  color: "red",
                }}
              >
                18+ Only
              </p>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </main>{" "}
    </div>
  );
}

export default LoginPage;